import { translate } from '@/domain/utils/translate';

/**
 * Librería de codigos de errores de producto base y variantes del back
 */
export enum ProductBackCodes {
  // Errores Producto base
  NON_EXISTENT_STORE_ERROR = 'EBP002',
  UNAUTHORIZED = 'EBP003',
  EXISTING_NAME_ERROR = 'EBP006',
  NON_EXISTENT_CATEGORY_ERROR = 'EBP009',
  LENGTH_URL_ERROR = 'EBP014',
  EXISTING_TAG_ERROR = 'EBP016',
  MAX_VARIANTS_ALLOWED_ERROR = 'EBP019',
  REQUIRED_PRODUCT_ERROR = 'EBP021',
  MAIN_PRODUCT_ERROR = 'EBP022',
  STATUS_ACTIVE_VALUE_ERROR = 'EBP023',
  DUPLICATED_SKU_ERROR = 'EBP024',
  STATUS_INACTIVE_VALUE_ERROR = 'EBP025',
  CATEGORY_ERROR = 'EBP026',
  MAIN_VARIANT_REQUIRED_ERROR = 'EBP027',
  DISABLE_MAIN_VARIANT_ERROR = 'EBP028',
  NON_EXISTENT_ID_ERROR = 'EBP029',
  EXISTING_MAIN_PRODUCT_ERROR = 'EBP030',
  REQUIRED_ID_ERROR = 'EBP031',
  INACTIVE_ERROR = 'EBP032',
  NON_EXISTENT_SHIPPING_ERROR = 'EBP018',
  // Errores Producto (variante)
  EXISTING_SKU_ERROR = 'EP002',
  REQUIRED_MAIN_ERROR = 'EP004',
  NON_EXISTENT_BRANCH_OFFICE_ERROR = 'EP006',
  NON_EXISTENT_TAX_ERROR = 'EP021',
  DUPLICATED_TAX_ERROR = 'EP022',
  NON_EXISTENT_STATUS_ERROR = 'EP026',
  NON_EXISTENT_ATTRIBUTE_ERROR = 'EP032',
  ATTRIBUTE_CATEGORY_ERROR = 'EP033',
  UNEXPECTED_DECIMAL_ATTRIBUTE_VALUE_ERROR = 'EP035',
  EXPECTED_DECIMAL_ATTRIBUTE_VALUE_ERROR = 'EP036',
  ATTRIBUTE_VALUE_RANGE_ERROR = 'EP037',
  NON_EXISTENT_PRODUCT_ID_ERROR = 'EP039',
  POSITION_ATTRIBUTES_ERROR = 'EP040',
  REPEATED_ATTRIBUTES_ERROR = 'EP041',
  ATTRIBUTE_VALUE_ERROR = 'EP045',
  INVALID_LENGTH_QUANTITY_ERROR = 'EP046',
  INVALID_SKU_CODE = 'EP047',
}

/**
 * Estructura de errores de producto base y variantes del back
 * IMPORTANTE - en los textos de los mensajes únicamente se permite :
 * REFERENCE_VALUE -> valor del campo
 * MIN_RANGE -> valor mínimo para rango
 * MAX_RANGE -> valor máximo para rango
 */
export interface IProductBackErrors {
  code: ProductBackCodes;
  message: string;
  key: string;
}
const getProductBackErrors = (): IProductBackErrors[] => [
  // Errores Producto base
  {
    code: ProductBackCodes.NON_EXISTENT_STORE_ERROR,
    message: translate('massive_charge.errors.non_exixtent_store'),
    key: 'ID_TIENDA',
  },
  {
    code: ProductBackCodes.UNAUTHORIZED,
    message: translate('massive_charge.errors.unauthorized'),
    key: 'PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.EXISTING_NAME_ERROR,
    message: translate('massive_charge.errors.existing_name'),
    key: 'NOMBRE_PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_CATEGORY_ERROR,
    message: translate('massive_charge.errors.non_existent_category'),
    key: 'CATEGORÍA_PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.LENGTH_URL_ERROR,
    message: translate('massive_charge.errors.length_url'),
    key: 'MEDIA_PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.EXISTING_TAG_ERROR,
    message: translate('massive_charge.errors.existing_tag'),
    key: 'TAGS_PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.MAX_VARIANTS_ALLOWED_ERROR,
    message: translate('massive_charge.errors.max_variants_allowed'),
    key: 'VARIANTES',
  },
  {
    code: ProductBackCodes.REQUIRED_PRODUCT_ERROR,
    message: translate('massive_charge.errors.required_product'),
    key: 'VARIANTES',
  },
  {
    code: ProductBackCodes.MAIN_PRODUCT_ERROR,
    message: translate('massive_charge.errors.main_product'),
    key: 'VARIANTES',
  },
  {
    code: ProductBackCodes.STATUS_ACTIVE_VALUE_ERROR,
    message: translate('massive_charge.errors.status_active'),
    key: 'PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.DUPLICATED_SKU_ERROR,
    message: translate('massive_charge.errors.duplicated_sku'),
    key: 'SKU_VARIANTES',
  },
  {
    code: ProductBackCodes.STATUS_INACTIVE_VALUE_ERROR,
    message: translate('massive_charge.errors.status_inactive'),
    key: 'PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.CATEGORY_ERROR,
    message: translate('massive_charge.errors.category'),
    key: 'CATEGORÍA_PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.MAIN_VARIANT_REQUIRED_ERROR,
    message: translate('massive_charge.errors.main_variant_required'),
    key: 'VARIANTES',
  },
  {
    code: ProductBackCodes.DISABLE_MAIN_VARIANT_ERROR,
    message: translate('massive_charge.errors.disable_main_variant'),
    key: 'VARIANTES',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_ID_ERROR,
    message: translate('massive_charge.errors.non_existent_id'),
    key: 'PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.EXISTING_MAIN_PRODUCT_ERROR,
    message: translate('massive_charge.errors.existing_main_product'),
    key: 'VARIANTES',
  },
  {
    code: ProductBackCodes.REQUIRED_ID_ERROR,
    message: translate('massive_charge.errors.requered_id'),
    key: 'PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.INACTIVE_ERROR,
    message: translate('massive_charge.errors.inactive'),
    key: 'PRODUCTO_BASE',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_SHIPPING_ERROR,
    message: translate('massive_charge.errors.non_exixting_shipping'),
    key: 'TIPO_DE_ENTREGA',
  },
  // Errores Producto (variante)
  {
    code: ProductBackCodes.EXISTING_SKU_ERROR,
    message: translate('massive_charge.errors.existing_sku'),
    key: 'SKU',
  },
  {
    code: ProductBackCodes.REQUIRED_MAIN_ERROR,
    message: translate('massive_charge.errors.required_main'),
    key: 'VARIANTE',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_BRANCH_OFFICE_ERROR,
    message: translate('massive_charge.errors.non_existing_office'),
    key: 'SUCURSAL',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_TAX_ERROR,
    message: translate('massive_charge.errors.non_existing_tax'),
    key: 'IMPUESTOS',
  },
  {
    code: ProductBackCodes.DUPLICATED_TAX_ERROR,
    message: translate('massive_charge.errors.duplicated_tax'),
    key: 'IMPUESTOS',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_STATUS_ERROR,
    message: translate('massive_charge.errors.non_existent_status'),
    key: 'ESTADO',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_ATTRIBUTE_ERROR,
    message: translate('massive_charge.errors.non_existing_attribute'),
    key: 'ATRIBUTOS',
  },
  {
    code: ProductBackCodes.ATTRIBUTE_CATEGORY_ERROR,
    message: translate('massive_charge.errors.attribute_category'),
    key: 'ATRIBUTOS',
  },
  {
    code: ProductBackCodes.UNEXPECTED_DECIMAL_ATTRIBUTE_VALUE_ERROR,
    message: translate('massive_charge.errors.unexpected_decimal_attribute'),
    key: 'ATRIBUTOS',
  },
  {
    code: ProductBackCodes.EXPECTED_DECIMAL_ATTRIBUTE_VALUE_ERROR,
    message: translate('massive_charge.errors.expected_decimal_attribute'),
    key: 'ATRIBUTOS',
  },
  {
    code: ProductBackCodes.ATTRIBUTE_VALUE_RANGE_ERROR,
    message: translate('massive_charge.errors.attribute_value_range'),
    key: 'ATRIBUTOS',
  },
  {
    code: ProductBackCodes.NON_EXISTENT_PRODUCT_ID_ERROR,
    message: translate('massive_charge.errors.non_exixtent_product_id'),
    key: 'VARIANTE',
  },
  {
    code: ProductBackCodes.POSITION_ATTRIBUTES_ERROR,
    message: translate('massive_charge.errors.position_attributes'),
    key: 'ATRIBUTOS',
  },
  {
    code: ProductBackCodes.REPEATED_ATTRIBUTES_ERROR,
    message: translate('massive_charge.errors.repeated_attributes'),
    key: 'VARIANTE',
  },
  {
    code: ProductBackCodes.ATTRIBUTE_VALUE_ERROR,
    message: translate('massive_charge.errors.attribute_value'),
    key: 'ATRIBUTOS',
  },
  {
    code: ProductBackCodes.INVALID_SKU_CODE,
    message: translate('massive_charge.errors.invalid_sku'),
    key: 'SKU',
  },
];

export default getProductBackErrors;
